import { useEffect, useState } from "react";
import dataService from "../../../helpers/dataService";

// Demandes d'assurance auto du particulier connecté (PER-2210).
// Échec silencieux : la section auto disparaît, le reste de la page vit
// (503 graal indisponible, futur 403 d'un profil sans accès).
// `actif` (PER-2207) : en espace entreprise, aucun appel réseau n'est déclenché.
// `autoErreur` : distingue « aucune demande » d'un échec de récupération. Sur la
// page Demandes, les deux cas se ressemblent (la section disparaît) ; sur
// l'accueil (PER-2208), un tableau vide déclencherait l'état vide « vous n'avez
// aucune demande », message faux quand c'est en réalité Graal qui est muet.
const useAutoRequests = (actif = true) => {
  const [isLoadingAuto, setIsLoadingAuto] = useState(false);
  const [autoRequests, setAutoRequests] = useState([]);
  const [autoErreur, setAutoErreur] = useState(false);

  useEffect(() => {
    if (!actif) return;
    setIsLoadingAuto(true);
    setAutoErreur(false);
    dataService.get(
      `customers/me/auto_requests`,
      (data) => setAutoRequests(Array.isArray(data) ? data : []),
      (err) => setAutoErreur(true),
      () => setIsLoadingAuto(false)
    );
  }, [actif]);

  return {
    autoRequests,
    hasAUTO: actif && autoRequests.length > 0,
    isLoadingAuto,
    autoErreur,
  };
};

export default useAutoRequests;
